/**
 * Vendor JavaScript
 * Third-party utilities and polyfills
 */

(function() {
  'use strict';

  /**
   * Polyfill for details/summary elements
   */
  if (!('open' in document.createElement('details'))) {
    document.documentElement.className += ' no-details';
  }

  /**
   * Polyfill for IntersectionObserver
   */
  if (!('IntersectionObserver' in window)) {
    console.warn('IntersectionObserver not supported');
  }

  /**
   * Cookie utility
   */
  window.Cookies = {
    set: function(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      const expires = 'expires=' + date.toUTCString();
      document.cookie = name + '=' + value + ';' + expires + ';path=/';
    },
    
    get: function(name) {
      const nameEQ = name + '=';
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
    
    remove: function(name) {
      document.cookie = name + '=; Max-Age=-99999999;';
    }
  };

  /**
   * Debounce utility
   */
  window.debounce = function(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };

  /**
   * Throttle utility
   */
  window.throttle = function(func, limit) {
    let inThrottle;
    return function() {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    };
  };

})();

